export const statusOptions = {
  PUBLISHED: 'active',
  DELETED: 'deleted',
  DRAFT: 'draft'
}

export const defaultValues = {
  TRADE: 'default',
  SERVICE: 'default',
  WORK_TYPE: 'default'
}

export const userRolesStrings = {
  VIEW_ONLY: 'View Only'
}
